import type { DeepPartial, MessageCatalog } from './types';

const hi: DeepPartial<MessageCatalog> = {
  nav: {
    home: 'FalaRus',
    partner: 'बातचीत',
    teachers: 'शिक्षक',
    stats: 'आँकड़े',
    profile: 'प्रोफ़ाइल',
  },
  profile: {
    tapPhoto: 'फ़ोटो बदलने के लिए टैप करें',
    premiumDaysLeft: 'Premium · {{days}} दिन बाकी',
    groups: {
      personal: 'व्यक्तिगत',
      settings: 'सेटिंग्स',
      help: 'सहायता',
    },
    rows: {
      profile: 'प्रोफ़ाइल',
      certificates: 'प्रमाणपत्र',
      invite: 'दोस्तों को आमंत्रित करें',
      textSize: 'टेक्स्ट आकार',
      notifications: 'सूचनाएँ',
      darkMode: 'डार्क मोड',
      language: 'भाषा',
      sound: 'ध्वनि और कंपन',
      help: 'सहायता',
      pricing: 'टैरिफ',
      paymentHistory: 'भुगतान इतिहास',
      logout: 'लॉग आउट',
    },
    firstName: 'नाम',
    lastName: 'उपनाम',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    nameUpdated: 'नाम अपडेट हुआ',
    avatarUpdated: 'प्रोफ़ाइल फ़ोटो अपडेट हुई',
    avatarUploadFailed: 'फ़ोटो अपलोड नहीं हो सकी',
    nameRequired: 'नाम और उपनाम आवश्यक हैं',
  },
  common: {
    user: 'उपयोगकर्ता',
    save: 'सहेजें',
    cancel: 'रद्द करें',
  },
  language: {
    selectTitle: 'भाषा चुनें',
    selectSubtitle: 'ऐप की भाषा',
  },
  auth: {
    benefits: {
    },
    register: 'साइन अप',
    logIn: 'लॉग इन',
    logInTitle: 'लॉग इन',
    createAccountTitle: 'खाता बनाएँ',
    phone: 'फ़ोन',
    email: 'ईमेल',
    password: 'पासवर्ड',
    createPassword: 'पासवर्ड बनाएँ',
    rewritePassword: 'पासवर्ड दोबारा दर्ज करें',
    name: 'नाम',
    surname: 'उपनाम',
    emailHint: 'username@gmail.com',
    forgotPassword: 'पासवर्ड भूल गए?',
    or: 'या',
    continueWithGoogle: 'Google से जारी रखें',
    noAccount: 'खाता नहीं है? ',
    signUp: 'साइन अप',
    haveAccount: 'पहले से खाता है? ',
    emailRequired: 'ईमेल आवश्यक है',
    emailInvalid: 'अमान्य ईमेल',
    phoneInvalid: 'अमान्य फ़ोन नंबर',
    passwordRequired: 'पासवर्ड आवश्यक है',
    passwordMinLength: 'पासवर्ड कम से कम 6 अक्षर का होना चाहिए',
    passwordsMismatch: 'पासवर्ड मेल नहीं खाते',
    nameRequired: 'नाम आवश्यक है',
    surnameRequired: 'उपनाम आवश्यक है',
    termsPrefix: 'खाता बनाकर मैं ',
    termsOfUse: 'उपयोग की शर्तें',
    termsAnd: ' और ',
    privacyPolicy: 'गोपनीयता नीति',
    termsSuffix: ' से सहमत हूँ।',
    resetTitle: 'पासवर्ड रीसेट',
    resetSubtitle: 'हम आपके ईमेल पर नया पासवर्ड भेजेंगे',
    resetSendPassword: 'नया पासवर्ड भेजें',
    resetSuccessTitle: 'ईमेल भेजा गया',
    resetSuccessSubtitle: 'यदि खाता मौजूद है, तो नया पासवर्ड आपके ईमेल पर भेज दिया गया है',
    networkError: 'इंटरनेट कनेक्शन नहीं है। कृपया फिर से कोशिश करें।',
    genericError: 'कुछ गलत हो गया',
  },
};

export default hi;
